<svg
  width="46"
  height="32"
  viewBox="0 0 46 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="11.75"
    y="0.75"
    width="21.5"
    height="14.5"
    rx="1.25"
    stroke="#7B90A4"
    stroke-width="1.5"
    [ngStyle]="{ stroke: strokeColor }"
  />
  <rect
    x="20.75"
    y="0.75"
    width="12.5"
    height="7.5"
    rx="1.25"
    stroke="#7B90A4"
    stroke-width="1.5"
    [ngStyle]="{ stroke: strokeColor }"
  />
</svg>
